import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  position: relative;
  inline-size: ${spacing(52)};
  block-size: ${spacing(16.25)};
`
export const rootMobile = css`
  position: relative;
  block-size: ${spacing(16.25)};
  margin: ${spacing(0, 2, 2)};
`
export const item = css`
  position: absolute;
  opacity: 0;
  inset: 0;
  transition: opacity 300ms;
`
export const active = css`
  opacity: 1;
`
